export const JOURNEY_EVENTS = {
  loginAttempt: "login_attempt",
  loginSuccess: "login_success",
  loginFailure: "login_failure",
  clickPay: "click_pay",
  createPlan: "create_plan",
  paymentCompleted: "payment_completed",
  chatOpened: "chat_opened",
};
